import type { ISupportChatApi, TrackEvent } from './api/client';

/**
 * Lightweight, PII-free event tracker. Buffers events and flushes them in
 * batches (and on pagehide via sendBeacon). Only event names, step ids and
 * status words are ever sent — never e-mails, names or message texts.
 */
export class SupportChatAnalytics {
	private buffer: TrackEvent[] = [];
	private timer: number | null = null;
	private conversationId: string | null = null;

	constructor(private readonly api: ISupportChatApi) {
		if (typeof window !== 'undefined') {
			window.addEventListener('pagehide', () => this.flush());
		}
	}

	setConversation(id: string | null) {
		this.conversationId = id;
	}

	track(name: string, extra: Partial<Omit<TrackEvent, 'name' | 'ts' | 'conversationId'>> = {}) {
		this.buffer.push({ name, ts: Date.now(), conversationId: this.conversationId, ...extra });
		if (this.buffer.length >= 10) {
			this.flush();
			return;
		}
		if (this.timer == null && typeof window !== 'undefined') {
			this.timer = window.setTimeout(() => this.flush(), 3000);
		}
	}

	flush() {
		if (this.timer != null) {
			clearTimeout(this.timer);
			this.timer = null;
		}
		if (!this.buffer.length) {
			return;
		}
		const batch = this.buffer;
		this.buffer = [];
		void this.api.track(batch);
	}
}
